export enum PointVisualizationMode {
    /**
     * Points are hidden.
     */
    Hidden,

    /**
     * Visualize points with original colors.
     */
    Original,

    /**
     * Paint all points belonging to a specific
     * cluster with the same random color.
     */
    Cluster,
}
